import React, { useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import JsBarcode from "jsbarcode";
import "./BarcodePrint.css"
import { Box, Button, Paper, Card, CardContent, Typography } from '@mui/material';

const LandDocBarcode = () => {
  const barcodeRef = useRef();
  const [searchParams] = useSearchParams();
  const parcelCode = searchParams.get("parcelCode");
  const oldParcel = searchParams.get("oldParcel");
  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, parcelCode, {
        format: "CODE128",
        width: 3,
        height: 50,
        displayValue: true,
        fontSize: 10,
      });
    }
  }, [parcelCode]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box className='otherSide' id="otherSide">
      <Box className='surveyLayouts' id="surveyLayouts"></Box>
      <Box textAlign="center" p={2}>
        {/* พื้นที่สั่งพิมพ์ */}
        <Box id="print-area" className="print-area" >
          <Paper
            elevation={0} // เอาเงาออกตอนปริ้น
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "white",
              p: 2
            }}
          >
            <Typography
              sx={{
                fontSize: "40px", // ลดจาก 100 เหลือประมาณ 40-50 ให้พอดี 1.5 นิ้ว
                fontWeight: "bold",
                lineHeight: 1,
              }}
            >
              {oldParcel}
            </Typography>
            <Box
              component="svg"
              ref={barcodeRef}
              sx={{ maxWidth: "90%" }} // ป้องกัน Barcode บานออกนอกแผ่น
            />
          </Paper>
        </Box>

        {/* ปุ่มกด (แสดงเฉพาะบนหน้าจอ) */}
        <Button
          variant="contained"
          color="secondary"
          onClick={handlePrint}
          sx={{ mt: 4 }}
          className="print-hidden" // คลาสสำหรับซ่อน
        >
          🖨️ พิมพ์เฉพาะฉลาก
        </Button>
      </Box>
    </Box>
  );
};

export default LandDocBarcode;
